import { useMemo } from "react";
import { createPortal } from "react-dom";

export function PortalContainer(props: React.ComponentProps<"div">) {
  return <div {...props} />;
}

export function Portal(
  props: React.PropsWithChildren & { selector: string; id?: string }
) {
  const container = useMemo(() => {
    const el = document.querySelector(props.selector);
    if (!el) {
      throw new Error(
        `Unable to find action bar portal with selector: ${props.selector}`
      );
    }
    return el;
  }, [props.selector]);

  return createPortal(props.children, container, props.id);
}
